
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BodyMapCanvas from "@/components/perioperatif/BodyMapCanvas.vue";

@Component({
  components: { BodyMapCanvas }
})
export default class ExposureSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    konjungtiva: "tak_anemis",
    sklera: "tak_ikterik",
    mukosa_mulut: "lembab",
    abdomen: ["supel"],
    bising_usus: "terdengar",
    bising_usus_frekuensi: null,
    jalur_nutrisi: ["oral"],
    tpn_ket: "",
    diet: "",
    bb: null,
    tb: null,
    bmi: null,
    warna_kulit: "",
    turgor_kulit: "",
    lesi: "",
    posisi_luka: "",
    body_map_data: [],
    body_map_png: null
  };

  bodyMapViews = [
    { kode: "tubuh_belakang_depan", label: "Tubuh — Tampak Belakang & Depan" }
  ];

  private snapshotTimer: number | null = null;

  abdomenOptions = [
    { text: "Supel", value: "supel" },
    { text: "Distensi", value: "distensi" },
    { text: "Ascites", value: "ascites" },
    { text: "Massa", value: "massa" },
    { text: "Striae", value: "striae" },
    { text: "Kolostomi", value: "kolostomi" }
  ];

  jalurOptions = [
    { text: "Oral", value: "oral" },
    { text: "Parenteral", value: "parenteral" },
    { text: "TPN", value: "tpn" }
  ];

  @Watch("form.bb")
  onBb() { this.recalcBmi(); }

  @Watch("form.tb")
  onTb() { this.recalcBmi(); }

  recalcBmi() {
    const bb = Number(this.form.bb);
    const tb = Number(this.form.tb);
    if (Number.isFinite(bb) && Number.isFinite(tb) && bb > 0 && tb > 0) {
      const tbM = tb / 100;
      this.form.bmi = Number((bb / (tbM * tbM)).toFixed(1));
    } else {
      this.form.bmi = null;
    }
  }

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
    if (!Array.isArray(this.form.body_map_data)) this.form.body_map_data = [];
  }

  mounted() {
    if (this.form.body_map_data.length && !this.form.body_map_png) {
      this.scheduleSnapshot();
    }
  }

  beforeDestroy() {
    if (this.snapshotTimer) window.clearTimeout(this.snapshotTimer);
  }

  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  @Watch("form.body_map_data", { deep: true })
  onBodyMapDataChange() { this.scheduleSnapshot(); }

  onBodyMapInput(markers: unknown[]) {
    this.$set(this.form, "body_map_data", markers);
  }

  scheduleSnapshot() {
    if (this.snapshotTimer) window.clearTimeout(this.snapshotTimer);
    this.snapshotTimer = window.setTimeout(() => {
      this.snapshotTimer = null;
      this.captureSnapshot();
    }, 300);
  }

  async captureSnapshot() {
    const canvas = this.$refs.bodyMap as any;
    if (!canvas || typeof canvas.snapshotPng !== "function") return;
    try {
      const png = await canvas.snapshotPng();
      if (png) this.$set(this.form, "body_map_png", png);
    } catch {
      return;
    }
  }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
    if (!Array.isArray(this.form.abdomen)) this.form.abdomen = [];
    if (!Array.isArray(this.form.jalur_nutrisi)) this.form.jalur_nutrisi = [];
    if (!Array.isArray(this.form.body_map_data)) this.form.body_map_data = [];
    this.recalcBmi();
  }
}
